module.exports = __webpack_public_path__ + "static/media/news_announcements.0a1fa78a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/components/news_announcements.svg
// module id = 1810
// module chunks = 0